import React from "react";
import { useParams } from "react-router-dom";
import { LayoutProvider, useLayout } from "./LayoutContext";
import ToolbarEnhanced from "../PanelLayout/Toolbar/ToolbarEnhanced";
import SetupPanel from "../Projects/panels/SetupPanel";
import ViewerPanel from "../Projects/panels/ViewerPanel";
import DevicesPanel from "../Projects/panels/Devices/DevicesPanel";
import ResizableWorkspace from "./ResizableWorkspace";
import "./Layout.css";

// Defined once outside the component so the workspace gets a stable list.
// Sizes are percentages of the width; the user's sizes and order are
// remembered per browser ("Reset layout" restores these defaults).
const PANELS = [
  { id: "setup",   title: "Setup",   defaultSize: "22%", minSize: "15%", render: () => <SetupPanel /> },
  { id: "viewer",  title: "Viewer",  defaultSize: "56%", minSize: "30%", render: () => <ViewerPanel /> },
  { id: "devices", title: "Devices", defaultSize: "22%", minSize: "15%", render: () => <DevicesPanel /> },
];

function Shell() {
  const L = useLayout();
  return (
    <div className="pl-app">
      <header className="pl-topbar">
        <ToolbarEnhanced selectedProject={L.selectedProject} projectName={L.projectName} onNameChange={L.handleNameChange} />
      </header>
      <main className="pl-workspace">
        <ResizableWorkspace panels={PANELS} />
      </main>
    </div>
  );
}

export default function Layout() {
  const { projectId } = useParams();
  return <LayoutProvider projectId={projectId} runEngine><Shell /></LayoutProvider>;
}
